/** ROUTES */

const staticBaseURL = "https://assets.pliability.com/pwa/";
export const muxPlaybackDomain = "content.pliability.com";
export const imagesURL = `${staticBaseURL}images/`;
export const assetsURL = `${staticBaseURL}assets/`;
export const videoURL = `${process.env.VIDEO_HOST || ""}`;
export const muxDataKey = `${process.env.MUX_DATA_KEY || ""}`;
export const castAppId = `${process.env.CAST_APP_ID || ""}`;
export const prosperStackClientId = `${
  process.env.PROSPER_STACK_CLIENT_ID || ""
}`;
export const pubPath = `${process.env.PUBLIC_PATH || ""}`;
export const pubPathNoTrailingSlash = pubPath
  ? pubPath.substring(0, pubPath.length - 1)
  : "";
export const gaUaId = `${process.env.GA_UA_ID || ""}`;
export const gAuthClientId = `${process.env.GOOGLE_AUTH_CLIENT_ID || ""}`;
export const appleServicesId = "com.romwod.romwod";
export const brazeAppId = `${process.env.BRAZE_APP_ID || ""}`;
export const welcomePathId = `${process.env.WELCOME_PATH_ID || "0"}`;
export const rudderstackWriteKey = `${process.env.RUDDERSTACK_WRITE_KEY || ""}`;
export const rudderstackDataPlaneUrl = `${process.env.RUDDERSTACK_DATA_PLANE_URL || ""}`;
export const dubPublishableKey = `${process.env.DUB_PUBLISHABLE_KEY || ""}`;
export const dubReferDomain = `${process.env.DUB_REFER_DOMAIN || "dub.sh"}`;
export const dubScriptSrc = process.env.DUB_SCRIPT_SRC || undefined;
export const dubApiHost = process.env.DUB_API_HOST || undefined;
export const streamHost = `${process.env.STREAM_HOST || "stream.pliability.com"}`;

/** PAGES */
export const itemsPerPage =
  typeof window !== "undefined"
    ? window.document.documentElement.clientHeight > 920
      ? 20
      : 12
    : 12;

/** Intercom */
export const intercomtTicketContact = `${
  process.env.INTERCOM_TICKET_CONTACT || ""
}`;

/** HSA/FSA Integration */
export const trueMedQualificationUrl =
  "https://app.truemed.com/qualify/tm_qual_gazpdz4nuh";
